import { FormControl, Input } from "kanopi-components/Input";
import React, { ChangeEvent } from "react";
import { TimePicker, TimepickerPrope } from "baseui/timepicker";

import { WidthContainer } from "../../ChatFlow/WidthContainer";

interface TimeInputProps {
  label: string;
  title?: string;
  help?: string;
  error?: string;
  hideLabel?: boolean;
  value: string;
}

export const TimeInput = ({
  label,
  title,
  help,
  error,
  hideLabel,
  value,
  ...props
}: TimeInputProps) => {
  return (
    <WidthContainer>
      <FormControl
        label={label}
        title={title}
        caption={help}
        error={error}
        hideLabel={hideLabel}
      >
        <TimePicker value={makeTime(value)} {...props} />
      </FormControl>
    </WidthContainer>
  );
};

const makeTime = (value: string | Date) => {
  if (value && !(value instanceof Date)) {
    value = new Date(value);
  }
  return value;
};
